import { useContext, useEffect, useState } from "react";
import RtlProvider from "../../../Components/RtlProvider"
import * as yup from 'yup';
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Grid, IconButton, List, ListItem, TextField, ThemeProvider, Tooltip } from "@mui/material";
import customtheme from '../../../themes';
import { ContextNotification, severitys } from '../../../App';
import { useSelector } from "react-redux";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import packageApi from "../../../api/packageApi";
import helper from "../../../helper";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import CustomDateInput from "../../../Components/CustomDateInput";
import moment from "jalali-moment";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin5Fill } from "react-icons/ri";
import EnumMapper from "../../../EnumMapper";


const EditPackageEvent = ({ Events, Refresh, IsLocal, LocalUpdate }) => {

    const { open, setOpen } = useContext(ContextNotification);
    const [isloading, setIsloading] = useState(false);
    const [city, setCity] = useState([]);
    const [eventType, setEventType] = useState([]);
    const [itemvalues, setItemValues] = useState([]);
    const [showError, setShowError] = useState(false);
    const customization = useSelector((state) => state.customization);
    const schema = yup.object().shape({

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({

        resolver: yupResolver(schema),

    });
    useEffect(() => {
        setShowError(false);
        getcityDropDown();
        getEventTypeDropDown();
        getItemValues();
    }, []);
    useEffect(() => {
        setShowError(false);
        getItemValues();
    }, [Events]);


    const getcityDropDown = () => {
        packageApi.GetArabiaCityDropDown().then((res) => {
            const arr = helper.DictionayToList(res.data.data);
            setCity(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        })
            .catch((err) => {
                console.log(err);
            });
    }

    const getEventTypeDropDown = () => {

        packageApi.GetEventTypeDropDown().then((res) => {
            const arr = helper.DictionayToList(res.data.data);
            setEventType(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        })
            .catch((err) => {
                console.log(err);
            });
    }
    const getItemValues = () => {
        const newvalues = Events?.map((item) => {
            return (
                {
                    "index": item.index,
                    "id": item.id,
                    "eventTypeId": item.value.eventTypeId,
                    "description": item.value.description,
                    "startT": item.value.startT,
                    "endT": item.value.endT,
                    "fromCity": item.value.fromCity,
                    "toCity": item.value.toCity
                })
        })
        setItemValues(newvalues);
        setvalues(newvalues);

    }
    const setvalues = (values) => {
        values?.map((item) => {
            setValue("eventTypeId" + String(item.index), String(item.eventTypeId));
            setValue("description" + String(item.index), item.description);
            setValue("startT" + String(item.index), item.startT);
            setValue("endT" + String(item.index), item.endT);
            setValue("eventTitle" + String(item.index), String(item.eventTitle));
            setValue("fromCity" + String(item.index), String(item.fromCity));
            setValue("toCity" + String(item.index), String(item.toCity));
        })
    }
    const resetForm = () => {
        setShowError(false);
        if (Event) {
            getItemValues();
        }
        else {
            setItemValues([]);
        }
    }
    const onSubmit = () => {

    }
    const EditEvent = (index, eventId) => {

        setShowError(false);
        let description = null;
        if (watch("description" + String(index)))
            description = watch("description" + String(index));

        let startT = null;
        if (watch("startT" + String(index)))
            startT = watch("startT" + String(index));

        let endT = null;
        if (watch("endT" + String(index)))
            endT = watch("endT" + String(index));

        let Eventdescr = null;
        if (watch("eventTitle" + String(index)))
            Eventdescr = watch("description" + String(index));
        let eventTypeId = null;
        if (watch("eventTypeId" + String(index))) {
            eventTypeId = parseInt(watch("eventTypeId" + String(index)));
        }

        let fromCity = null;
        if (watch("fromCity" + String(index))) {
            fromCity = parseInt(watch("fromCity" + String(index)));
        }

        let toCity = null;
        if (watch("toCity" + String(index))) {
            toCity = parseInt(watch("toCity" + String(index)));
        }
        if (!(helper.checkRequiredInputSurvey(eventTypeId, Eventdescr, startT, fromCity, endT, toCity))) {
            setShowError(true);
        }
        else {

            if (IsLocal) {

                const updatedata = {
                    "description": Eventdescr,
                    "eventTypeId": eventTypeId,
                    "eventTypeText": eventType.find((et) => parseInt(et.id) === parseInt(eventTypeId))?.label,
                    "fromCity": fromCity,
                    "fromCityText": city.find((et) => parseInt(et.id) === parseInt(fromCity))?.label,
                    "toCity": toCity,
                    "toCityText": city.find((et) => parseInt(et.id) === parseInt(toCity))?.label,
                    "startT": startT,
                    "endT": endT,
                }
                LocalUpdate(index, updatedata);
            }
            else {

                const eventdata =
                {
                    "description": Eventdescr,
                    "eventType": eventTypeId,
                    "fromCity": fromCity,
                    "toCity": toCity,
                    "startT": startT,
                    "endT": endT
                }
                setIsloading(true);
                packageApi.EditPackageEvent(eventId, eventdata).then((res) => {
                    if (res.data.success) {
                        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                        Refresh();
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
                    }
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                    }
                    else if (err.response && err.response.data) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                    }
                    else if (err.message) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                    }
                    else {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
                    }
                }
                ).finally(() => setIsloading(false));
            }

        }



    }

    const RemoveEvent = (id) => {
        setIsloading(true);
        packageApi.DeactivePackageEvent(id).then((res) => {
            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                Refresh();
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => setIsloading(false));
    }

    return (
        <ThemeProvider theme={customtheme(customization)}>
            <RtlProvider>
                <Box style={{ display: 'flex', border: '1px solid gray', borderRadius: 7 }} sx={{ mt: 1 }}>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <List sx={{ width: '100%' }}>
                            {itemvalues?.sort((a, b) => a.index >= b.index ? 1 : -1).map((item) => {
                                return (
                                    <ListItem>
                                        <Grid container spacing={1}>
                                            <Grid item md={3.5} xs={12} >
                                                <RHFAutocomplete
                                                    control={control}
                                                    options={eventType}
                                                    name={'eventTypeId' + String(item.index)}
                                                    placeholder="نوع رویداد"
                                                    style={{
                                                        border: "none",
                                                        padding: 0
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item md={3.5} xs={12}>
                                                <TextField label="شرح رویداد سفر"  {...register("description" + String(item.index))} fullWidth ></TextField>
                                            </Grid>
                                            {String(watch('eventTypeId' + String(item.index))) !== String(EnumMapper.PackageDetailsEventType.ReservePlanRequest) &&
                                                <Grid item md={1.5} xs={5} >
                                                    <Controller
                                                        control={control}
                                                        name={'startT' + String(item.index)}
                                                        rules={{ required: true }}
                                                        render={({ field: { onChange, value } }) => {
                                                            const pickerValue =
                                                                value && typeof value === "string"
                                                                    ? moment(value, "HH:mm").toDate()
                                                                    : value;
                                                            return (
                                                                <DatePicker
                                                                    disableDayPicker
                                                                    format="HH:mm"
                                                                    value={pickerValue}
                                                                    onChange={(date) => {
                                                                        if (date?.isValid) {
                                                                            const formatted = moment(date.toDate()).format("HH:mm");
                                                                            onChange(formatted);
                                                                        } else {
                                                                            onChange("");
                                                                        }
                                                                    }}
                                                                    plugins={[<TimePicker hideSeconds />]}
                                                                    render={<CustomDateInput label={"از ساعت"} />}
                                                                />
                                                            );
                                                        }}
                                                    />

                                                </Grid>}
                                            <Grid item md={1.5} xs={5}>
                                                <RHFAutocomplete
                                                    control={control}
                                                    options={city}
                                                    name={'fromCity' + String(item.index)}
                                                    placeholder="از شهر"
                                                    style={{
                                                        border: "none",
                                                        padding: 0
                                                    }}
                                                />
                                            </Grid>

                                            {(String(watch('eventTypeId' + String(item.index))) !== String(EnumMapper.PackageDetailsEventType.InnerCity)) &&
                                                (String(watch('eventTypeId' + String(item.index))) !== String(EnumMapper.PackageDetailsEventType.AtTheDisposalOfTheGroup)) &&
                                                (String(watch("eventTypeId" + String(item.index))) !== String(EnumMapper.PackageDetailsEventType.AtYourDisposal))
                                                && <>
                                                    {String(watch('eventTypeId' + String(item.index))) !== String(EnumMapper.PackageDetailsEventType.ReservePlanRequest) &&
                                                        <Grid item md={1.5} xs={5} >
                                                            <Controller
                                                                control={control}
                                                                name={'endT' + String(item.index)}
                                                                rules={{ required: true }}
                                                                render={({ field: { onChange, value } }) => {
                                                                    const pickerValue =
                                                                        value && typeof value === "string"
                                                                            ? moment(value, "HH:mm").toDate()
                                                                            : value;

                                                                    return (
                                                                        <DatePicker
                                                                            disableDayPicker
                                                                            format="HH:mm"
                                                                            value={pickerValue}
                                                                            onChange={(date) => {
                                                                                if (date?.isValid) {
                                                                                    const formatted = moment(date.toDate()).format("HH:mm");
                                                                                    onChange(formatted);
                                                                                } else {
                                                                                    onChange("");
                                                                                }
                                                                            }}
                                                                            plugins={[<TimePicker hideSeconds />]}
                                                                            render={<CustomDateInput label={"تا ساعت"} />}
                                                                        />
                                                                    );
                                                                }}
                                                            />

                                                        </Grid>
                                                    }
                                                    <Grid item md={1.5} xs={5}>
                                                        <RHFAutocomplete
                                                            control={control}
                                                            options={city}
                                                            name={'toCity' + String(item.index)}
                                                            placeholder="به شهر"
                                                            style={{
                                                                border: "none",
                                                                padding: 0
                                                            }}
                                                        />
                                                    </Grid>

                                                </>
                                            }
                                            <Grid item md={1} xs={1}>
                                                <Tooltip title="ویرایش">
                                                    <IconButton edge="end" sx={{mt:1}} aria-label={'ویرایش'} onClick={() => EditEvent(item.index, item.id)}>
                                                        <BeatLoading loading={isloading} color={"#e65100"} />
                                                        <TbEdit color='#4a148c' />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                            {(!IsLocal) && <Grid item md={1} xs={1}>
                                                <Tooltip title="حذف">
                                                    <IconButton edge="end"  sx={{mt:1}} aria-label={'حذف'} onClick={() => RemoveEvent(item.id)}>
                                                        <BeatLoading loading={isloading} color={"#e65100"} />
                                                        <RiDeleteBin5Fill color='#C7253E' />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                            }
                                            {(showError) && <p className="error">{' موارد خواسته شده را تکمیل کنید'}</p>}

                                        </Grid>



                                    </ListItem>
                                )

                            })}

                        </List>
                    </form>
                </Box>
            </RtlProvider>
        </ThemeProvider >
    );

}
export default EditPackageEvent;